import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Contact } from "../../../types/common";

export type ContactState = Contact[];

const initialState: ContactState = [];

const contactSlice = createSlice({
    name: "contact",
    initialState,
    reducers: {
        setContact(state, action: PayloadAction<Contact[]>) {
            return action.payload;
        },
    },
});

const { setContact } = contactSlice.actions;

const contactReducer = contactSlice.reducer;

export { setContact };
export default contactReducer;
